import { useTranslation } from 'react-i18next';
import { Game as GameType } from '~types';

export function useLocalizedItemName(item?: GameType['getItem']) {
  const { i18n } = useTranslation();

  if (!item) return '';

  return i18n.language === 'ru' ? item.name : item.name_en;
}
